import {StockOperationType} from "../api";

const stockOperationTypeTranslations: Record<StockOperationType, string> = {
    [StockOperationType.Pz]: "Przyjęcie zewnętrzne",
    [StockOperationType.Wz]: "Wydanie zewnętrzne",
    [StockOperationType.Mm]: "Przesunięcie międzymagazynowe",
    [StockOperationType.Vn]: "Produkcja",
    [StockOperationType.Oi]: "Inwentaryzacja",
    [StockOperationType.Pw]: "Przyjęcie wewnętrzne",
    [StockOperationType.Rw]: "Wydanie wewnętrzne",
    [StockOperationType.Opp]: "Operacja produkcyjna",
    [StockOperationType.Opw]: "Produkcja – zużycie",
};

const stockOperationTypeTranslationHelper = (type: StockOperationType) =>
    stockOperationTypeTranslations[type] ?? "";

const stockOperationTypeCodeHelper = (type: StockOperationType) =>
    type === StockOperationType.Opp ? "OP" : type;

const stockOperationTypeLabelHelper = (type: StockOperationType) => {
    const code = stockOperationTypeCodeHelper(type);
    const translation = stockOperationTypeTranslationHelper(type);

    return translation ? `${code} - ${translation}` : code;
};

export default stockOperationTypeTranslationHelper;
export {
    stockOperationTypeCodeHelper,
    stockOperationTypeLabelHelper,
    stockOperationTypeTranslationHelper
};
